const useSmoothScroll = true;
const scrollHorizontal = !useSmoothScroll;
const showMarkers = !useSmoothScroll;
gsap.registerPlugin(ScrollTrigger);
gsap.registerPlugin(ScrollToPlugin);
const initMouseWheel = () => {
    $('html, body, *').mousewheel(function (e, delta) {
        if ($('.menu-expanded').hasClass('open')) {
            return;
        }
        this.scrollLeft -= 90 * (delta);
    });
};
const initAnimation = () => {
    const sections = gsap.utils.toArray("section");
    let container = document.querySelector(".homepage");
    let elements = gsap.utils.toArray(document.querySelectorAll("section > *"));
    if (useSmoothScroll) {
        const tl = gsap.timeline({
            scrollTrigger: {
                pin: true,
                scrub: 1,
                overwrite: "auto",
                trigger: container,
                end: () => container.scrollWidth - document.documentElement.clientWidth
            }
        });
        tl.to(sections, {
            x: () => -(container.scrollWidth - document.documentElement.clientWidth) + "px",
            ease: "none",
        });
        $("#menu-open-btn").click(() => tl.scrollTrigger.disable(false));
        $("#menu-close-btn").click(() => tl.scrollTrigger.enable());
    }
    gsap.to('.section-1-inner', {
        backgroundPositionX: "45rem",
        overwrite: "auto",
        scrollTrigger: {
            scrub: 1,
            horizontal: scrollHorizontal,
            markers: showMarkers,
            start: "center center",
            end: 'right left',
        }
    });
    // gsap.from('.section-1-inner-block-2', {
    //     xPercent: 300,
    //     overwrite: "auto",
    //     scrollTrigger: {
    //         scrub: 1,
    //         horizontal: scrollHorizontal,
    //         markers: showMarkers,
    //         start: 'left center',
    //         end: 'right left',
    //     }
    // });
    gsap.to('.section-2>.section-read-more-inner', {
        paddingLeft: `calc(${$('.section-2>.section-read-more-inner').width()}px - 75rem)`,
        overwrite: "auto",
        scrollTrigger: {
            scrub: 1,
            horizontal: scrollHorizontal,
            markers: showMarkers,
            start: () => $('.section-2>.section-read-more-inner').offset().left,
            end: () => $('.section-2>.section-read-more-inner').offset().left +
                $('.section-2>.section-read-more-inner').width()
        }
    });
    gsap.to('.section-3-inner', {
        backgroundPositionX: "-70rem",
        overwrite: "auto",
        scrollTrigger: {
            trigger: '.section-3-inner',
            scrub: 1,
            horizontal: scrollHorizontal,
            markers: showMarkers,
            start: () => $('.section-3-inner').offset().left,
            end: () => $('.section-3-inner').offset().left +
                $('.section-3-inner').width()
        }
    });
    gsap.to('.section-4>.section-read-more-inner', {
        paddingLeft: `calc(${$('.section-4>.section-read-more-inner').width()}px - 75rem)`,
        overwrite: "auto",
        scrollTrigger: {
            scrub: 1,
            horizontal: scrollHorizontal,
            markers: showMarkers,
            start: () => $('.section-4>.section-read-more-inner').offset().left,
            end: () => $('.section-4>.section-read-more-inner').offset().left +
                $('.section-4>.section-read-more-inner').width()
        }
    });
    gsap.to('.section-5-inner', {
        backgroundPositionX: "-105rem",
        overwrite: "auto",
        scrollTrigger: {
            trigger: '.section-5-inner',
            scrub: 1,
            horizontal: scrollHorizontal,
            markers: showMarkers,
            start: () => $('.section-5-inner').offset().left -
                $('.section-5-inner').width() / 2,
            end: () => $('.section-5-inner').offset().left +
                $('.section-5-inner').width()
        }
    });
    gsap.to('.section-6>.section-read-more-inner', {
        paddingLeft: `calc(${$('.section-6>.section-read-more-inner').width()}px - 75rem)`,
        overwrite: "auto",
        scrollTrigger: {
            scrub: 1,
            horizontal: scrollHorizontal,
            markers: showMarkers,
            start: () => $('.section-6>.section-read-more-inner').offset().left,
            end: () => $('.section-6>.section-read-more-inner').offset().left +
                $('.section-6>.section-read-more-inner').width()
        }
    });
    gsap.from('.section-7-inner', {
        backgroundPositionX: "-165rem",
        overwrite: "auto",
        scrollTrigger: {
            trigger: '.section-7-inner',
            scrub: 1,
            horizontal: scrollHorizontal,
            markers: showMarkers,
            start: () => $('.section-7-inner').offset().left - $('.section-7-inner').width() / 2,
            end: () => $('.section-7-inner').offset().left +
                $('.section-7-inner').width()
        }
    });
    // gsap.from('.section-9-inner', {
    //     backgroundPositionX: "-165rem",
    //     overwrite: "auto",
    //     scrollTrigger: {
    //         trigger: '.section-9-inner',
    //         scrub: 1,
    //         horizontal: scrollHorizontal,
    //         markers: showMarkers,
    //         start: () => $('.section-9-inner').offset().left - $('.section-7-inner').width() / 2,
    //         end: () =>
    //             $('.section-9-inner').offset().left +
    //             $('.section-9-inner').width()
    //     }
    // });
    gsap.to('.section-10>.section-read-more-inner', {
        paddingLeft: `calc(${$('.section-10>.section-read-more-inner').width()}px - 75rem)`,
        overwrite: "auto",
        scrollTrigger: {
            scrub: 1,
            horizontal: scrollHorizontal,
            markers: showMarkers,
            start: () => $('.section-10>.section-read-more-inner').offset().left,
            end: () => $('.section-10>.section-read-more-inner').offset().left +
                $('.section-10>.section-read-more-inner').width()
        }
    });
    gsap.from('.section-11-inner', {
        backgroundPositionX: "-165rem",
        overwrite: "auto",
        scrollTrigger: {
            trigger: '.section-9-inner',
            scrub: 1,
            horizontal: scrollHorizontal,
            markers: showMarkers,
            start: () => $('.section-11-inner').offset().left - $('.section-7-inner').width() / 2,
            end: () => $('.section-11-inner').offset().left +
                $('.section-11-inner').width()
        }
    });
    // gsap.to('.section-12>.section-read-more-inner', {
    //     paddingLeft: `calc(${$('.section-12>.section-read-more-inner').width()}px - 75rem)`,
    //     overwrite: "auto",
    //     scrollTrigger: {
    //         scrub: 1,
    //         horizontal: scrollHorizontal,
    //         markers: showMarkers,
    //         start: () => $('.section-12>.section-read-more-inner').offset().left,
    //         end: () =>
    //             $('.section-12>.section-read-more-inner').offset().left +
    //             $('.section-12>.section-read-more-inner').width()
    //     }
    // });
};
$('.intro .skip').click(() => {
    $('.intro').remove();
    $('html').removeClass('overflow-hidden');
});
const getVideoSource = () => {
    const isLandscape = screen?.orientation?.type?.includes('landscape') || (document.documentElement.clientWidth > document.documentElement.clientHeight);
    const src = isLandscape ? '/2020/assets/intro.mp4' : '/2020/assets/intro_m.mp4';
    const video = $('<video loop muted playsinline></video>');
    $('<source />', {
        src,
    }).appendTo(video);
    $('.intro').prepend(video);
    video[0].play && video[0].play()
        .then(() => {
    }).catch(e => {
        $('.intro .skip').click();
    });
    $(video).on("play", function () {
        const videoTimeout = setTimeout(() => {
            $('.intro .skip').click();
        }, 28000);
    });
};
$(document).ready(() => {
    if ($('.homepage').length) {
        $('html').addClass('home');
        if (!useSmoothScroll) {
            initMouseWheel();
        }
        initAnimation();
        getVideoSource();
    }
});
if ($('.homepage').length) {
    $('html').addClass('overflow-hidden');
}
//# sourceMappingURL=homepage.js.map